export { reload, replace, pathname, location, href, origin, search, open, assign, isValidLocation } from './location';
